import * as yup from 'yup';

import { REGEXP } from 'constants/commonConstants';
import { Framework, ModelDirection, ProjectInfoFormValues } from 'types';

export const projectInfoSchema: yup.ObjectSchema<ProjectInfoFormValues> = yup.object().shape({
  projectName: yup
    .string()
    .required('프로젝트 이름을 입력해주세요.')
    .matches(REGEXP.PROJECT_NAME, '특수문자는 -, _만 가능하며 2-50자 이내로 입력해주세요.'),
  template: yup.string().required('템플릿을 선택해주세요.'),
  framework: yup.string<Framework>().required('프레임워크를 선택해주세요').defined(),
  frameworkVersion: yup.string().required('프레임워크 버전을 선택해주세요.'),
  direction: yup.string<ModelDirection>().required('모델 방향을 선택해주세요.').defined(),
  ownerName: yup.string(),
  newProjectName: yup.string(),
});
